/**
 * Converts a numeric value assumed to be in Tailwind units to `rem` (returns a string containing the `rem` unit, unless `asNumber` is `true`).
 */

import twToPx from '@/helpers/twToPx'
import pxToRem from '@/helpers/pxToRem'

export default (valueInTwUnits, asNumber = false) => pxToRem(twToPx(valueInTwUnits, true), asNumber)
